/**
 * Party Detection Actions
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

function cleanData (data) {
  return {
    parties: data.map(item => ({
      first_name: item.first_name,
      middle_name: item.middle_name,
      last_name: item.last_name,
      reference: item.reference,
    })),
  }
}

export const DetectionActions = {
  async detectAdversity (_, data) {
    return axiosRequest.
      post('/parties/adversities/single', { adversity: { party: data } }).
      then(({ data }) => data?.data).
      catch(handleError)
  },

  async detectDuplicate (_, data) {
    return axiosRequest.
      post('/parties/duplicates/single', { duplicate: { party: data } }).
      then(({ data }) => data?.data).
      catch(handleError)
  },

  async detectMultipleAdversities (_, data) {
    const cleanedData = cleanData(data)

    return axiosRequest.
      post('/parties/adversities/multiple', { adversity: cleanedData }).
      then(({ data }) => data?.data).
      catch(handleError)
  },

  async detectMultipleDuplicates (_, data) {
    const cleanedData = cleanData(data)

    return axiosRequest.
      post('/parties/duplicates/multiple', { duplicate: cleanedData }).
      then(({ data }) => data?.data).
      catch(handleError)
  },
}
